<template>
  <el-upload
    :show-file-list="false"
    :file-list="[]"
    :action="uploadUrl"
    :on-success="handlePictureCardPreview"
    :on-remove="handleRemove"
     :before-upload="beforeVideoUpload1"
    :headers="headers"
    name="files"
    :limit="1"
    :multiple="false"
    accept=".jpg,.jpeg,.png"
  >
    <div class="upload-image">
      <el-image
        class="icon"
        v-if="!picture"
        src="https://image2.soole.com.cn/slb-picture2025051315383166219.jpg"
      ></el-image>
      <el-image
        class="urlImage"
        :src="picture"
        v-else
        fit="scale-down"
      ></el-image>
    </div>
  </el-upload>
</template>

<script>
export default {
  props: {
    value: {
      type: String,
      default: "",
    },
    type: {
      type: Number,
      default: 3,
    },
  },
  data() {
    return {
      picture: "",
      headers: {
        Authorization: localStorage.getItem("token"),
      },
      uploadUrl: process.env.VUE_APP_API + "/api/common/fileInfo/newUpload",
    };
  },
  watch: {
    "props.value": {
      handler(newVal) {
        this.picture = newVal;
      },
      immediate: true,
    },
  },
  methods: {
      // 上传视频背景图片限制
    beforeVideoUpload1(file, fileList) {
       return new Promise((resolve, reject) => {
            const isImage = file.type.includes('image/');
            if (!isImage) {
              this.$message.error('只能上传图片文件');
              return reject();
            }
            
            const isLt5M = file.size / 1024 / 1024 < 10;
            if (!isLt5M) {
              this.$message.error('图片大小不能超过 10MB');
              return reject();
            }
            
            const reader = new FileReader();
            reader.readAsDataURL(file);
            
            reader.onload = (e) => {
              const image = new Image();
              image.src = e.target.result;
              
              image.onload = () => {
                const width = image.width;
                const height = image.height;
                // 验证分辨率
                if (this.validateDimensions(width, height)) {
                  resolve();
                } else {
                  this.$message.error(`图片分辨率 ${width}×${height} 不符合要求`);
                  reject();
                }
              };
            };
            
            reader.onerror = () => {
              this.$message.error('图片读取失败');
              reject();
            };
          });
    },
    // 分辨率校验
    validateDimensions(width, height) {
          if(this.type==3){
            if (width == 1080 && height == 1920) return true;
          }else if(this.type==4){
          if(height == 1080 &&  width== 1920) return true
          }else{
            return false
          }
        },
    handlePictureCardPreview(response) {
      if (Array.isArray(response.data) && response.data.length > 0) {
        this.picture = response.data[0].fileUrl;
        this.$emit("success", this.picture);
      }
    },

    handleRemove() {
      // 删除图片
      this.picture = "";
    },
  },
};
</script>

<style scoped lang="scss">
.upload-image {
  background-color: rgba(172, 178, 195, 0.2);
  width: 120px;
  height: 213px;
  display: flex;
  align-items: center;
  justify-content: center;

  .icon {
    width: 26px;
    height: 26px;
  }

  .urlImage {
    width: 100%;
    height: 100%;
  }
  .tips{
  font-size: 12;
  color: #999;
}
}
</style>
